import { render } from "./RealEstatesList.vue?vue&type=template&id=2d60eeb5"
import script from "./RealEstatesList.vue?vue&type=script&lang=js"
export * from "./RealEstatesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__